// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { provideStoreDevtools } from '@ngrx/store-devtools';
import {
  CRYPTO_CURRENCY_NAME,
  CRYPTO_CURRENCY_TYPE,
} from '@common-lib/view-model/currency/currency.type';

export const environment = {
  availableBlockchain: [
    CRYPTO_CURRENCY_TYPE.XBT,
    CRYPTO_CURRENCY_TYPE.ETH,
    CRYPTO_CURRENCY_TYPE.TRON,
    CRYPTO_CURRENCY_TYPE.TON,
    CRYPTO_CURRENCY_TYPE.BSC,
    CRYPTO_CURRENCY_TYPE.POLYGON,
    CRYPTO_CURRENCY_TYPE.SOLANA,
    CRYPTO_CURRENCY_TYPE.DOGECOIN,
    CRYPTO_CURRENCY_TYPE.LITECOIN,
    CRYPTO_CURRENCY_TYPE.ARBITRUM,
    CRYPTO_CURRENCY_TYPE.XRPL,
  ],
  availableCurrency: {
    [CRYPTO_CURRENCY_TYPE.XBT]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.XBT,
        value: CRYPTO_CURRENCY_TYPE.XBT,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.ETH]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.ETH,
        value: CRYPTO_CURRENCY_TYPE.ETH,
      },
      {
        name: CRYPTO_CURRENCY_NAME.USDT,
        value: CRYPTO_CURRENCY_TYPE.USDT,
      },
      {
        name: CRYPTO_CURRENCY_NAME.PEPE,
        value: CRYPTO_CURRENCY_TYPE.PEPE,
      },
      {
        name: CRYPTO_CURRENCY_NAME.SHIB,
        value: CRYPTO_CURRENCY_TYPE.SHIB,
      },
      {
        name: CRYPTO_CURRENCY_NAME.ARB,
        value: CRYPTO_CURRENCY_TYPE.ARB,
      },
      {
        name: CRYPTO_CURRENCY_NAME.USDC,
        value: CRYPTO_CURRENCY_TYPE.USDC,
      },
      {
        name: CRYPTO_CURRENCY_NAME.UNI,
        value: CRYPTO_CURRENCY_TYPE.UNI,
      },
      {
        name: CRYPTO_CURRENCY_NAME.LDO,
        value: CRYPTO_CURRENCY_TYPE.LDO,
      },
      {
        name: CRYPTO_CURRENCY_NAME.MKR,
        value: CRYPTO_CURRENCY_TYPE.MKR,
      },
      {
        name: CRYPTO_CURRENCY_NAME.GALA,
        value: CRYPTO_CURRENCY_TYPE.GALA,
      },
      {
        name: CRYPTO_CURRENCY_NAME.LINK,
        value: CRYPTO_CURRENCY_TYPE.LINK,
      },
      {
        name: CRYPTO_CURRENCY_NAME.IMX,
        value: CRYPTO_CURRENCY_TYPE.IMX,
      },
      {
        name: CRYPTO_CURRENCY_NAME.MANA,
        value: CRYPTO_CURRENCY_TYPE.MANA,
      },
      {
        name: CRYPTO_CURRENCY_NAME.SAND,
        value: CRYPTO_CURRENCY_TYPE.SAND,
      },
      {
        name: CRYPTO_CURRENCY_NAME.DYDX,
        value: CRYPTO_CURRENCY_TYPE.DYDX,
      },
      {
        name: CRYPTO_CURRENCY_NAME.BLUR,
        value: CRYPTO_CURRENCY_TYPE.BLUR,
      },
      {
        name: CRYPTO_CURRENCY_NAME.AXS,
        value: CRYPTO_CURRENCY_TYPE.AXS,
      },
      {
        name: CRYPTO_CURRENCY_NAME.XAUT,
        value: CRYPTO_CURRENCY_TYPE.XAUT,
      },
      /*{
        name: CRYPTO_CURRENCY_NAME.RUBT,
        value: CRYPTO_CURRENCY_TYPE.RUBT,
      },*/
      {
        name: CRYPTO_CURRENCY_NAME.STRK,
        value: CRYPTO_CURRENCY_TYPE.STRK,
      },
      {
        name: CRYPTO_CURRENCY_NAME.AAVE,
        value: CRYPTO_CURRENCY_TYPE.AAVE,
      },
      {
        name: CRYPTO_CURRENCY_NAME.APE,
        value: CRYPTO_CURRENCY_TYPE.APE,
      },
      {
        name: CRYPTO_CURRENCY_NAME.STBL,
        value: CRYPTO_CURRENCY_TYPE.STBL,
      },
      {
        name: CRYPTO_CURRENCY_NAME.DAI,
        value: CRYPTO_CURRENCY_TYPE.DAI,
      },
      {
        name: CRYPTO_CURRENCY_NAME.RUC,
        value: CRYPTO_CURRENCY_TYPE.RUC,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.TRON]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.TRX,
        value: CRYPTO_CURRENCY_TYPE.TRX,
      },
      {
        name: CRYPTO_CURRENCY_NAME.USDT_T,
        value: CRYPTO_CURRENCY_TYPE.USDT_T,
      },
      {
        name: CRYPTO_CURRENCY_NAME.JST,
        value: CRYPTO_CURRENCY_TYPE.JST,
      },
      /*{
        name: CRYPTO_CURRENCY_NAME.RUC_T,
        value: CRYPTO_CURRENCY_TYPE.RUC_T,
      },*/
    ],
    [CRYPTO_CURRENCY_TYPE.TON]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.GRAM,
        value: CRYPTO_CURRENCY_TYPE.GRAM,
      },
      {
        default: false,
        name: CRYPTO_CURRENCY_NAME.USDT_TON,
        value: CRYPTO_CURRENCY_TYPE.USDT_TON,
      },
      {
        default: false,
        name: CRYPTO_CURRENCY_NAME.TON,
        obsolete: true,
        value: CRYPTO_CURRENCY_TYPE.TON,
      },
      /*{
        name: CRYPTO_CURRENCY_NAME.RUBT_TON,
        value: CRYPTO_CURRENCY_TYPE.RUBT_TON,
      },*/
      {
        name: CRYPTO_CURRENCY_NAME.RUC_TON,
        value: CRYPTO_CURRENCY_TYPE.RUC_TON,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.BSC]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.BNB,
        value: CRYPTO_CURRENCY_TYPE.BNB,
      },
      {
        name: CRYPTO_CURRENCY_NAME.USDT_BSC,
        value: CRYPTO_CURRENCY_TYPE.USDT_BSC,
      },
      {
        name: CRYPTO_CURRENCY_NAME.KGST,
        value: CRYPTO_CURRENCY_TYPE.KGST,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.POLYGON]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.POL,
        value: CRYPTO_CURRENCY_TYPE.POL,
      },
      {
        name: CRYPTO_CURRENCY_NAME.USDT_POL,
        value: CRYPTO_CURRENCY_TYPE.USDT_POL,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.SOLANA]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.SOL,
        value: CRYPTO_CURRENCY_TYPE.SOL,
      },
      {
        name: CRYPTO_CURRENCY_NAME.TRUMP,
        value: CRYPTO_CURRENCY_TYPE.TRUMP,
      },
      {
        name: CRYPTO_CURRENCY_NAME.BONK,
        value: CRYPTO_CURRENCY_TYPE.BONK,
      },
      {
        name: CRYPTO_CURRENCY_NAME.USDT_SOL,
        value: CRYPTO_CURRENCY_TYPE.USDT_SOL,
      },
      {
        name: CRYPTO_CURRENCY_NAME.USDC_SOL,
        value: CRYPTO_CURRENCY_TYPE.USDC_SOL,
      },
      {
        name: CRYPTO_CURRENCY_NAME.AAPLX,
        value: CRYPTO_CURRENCY_TYPE.AAPLX,
      },
      {
        name: CRYPTO_CURRENCY_NAME.TSLAX,
        value: CRYPTO_CURRENCY_TYPE.TSLAX,
      },
      {
        name: CRYPTO_CURRENCY_NAME.NVDAX,
        value: CRYPTO_CURRENCY_TYPE.NVDAX,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.DOGECOIN]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.DOGE,
        value: CRYPTO_CURRENCY_TYPE.DOGE,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.ARBITRUM]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.ETH_ARB,
        value: CRYPTO_CURRENCY_TYPE.ETH_ARB,
      },
      {
        name: CRYPTO_CURRENCY_NAME.ARB_ARB,
        value: CRYPTO_CURRENCY_TYPE.ARB_ARB,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.LITECOIN]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.LTC,
        value: CRYPTO_CURRENCY_TYPE.LTC,
      },
    ],
    [CRYPTO_CURRENCY_TYPE.XRPL]: [
      {
        default: true,
        name: CRYPTO_CURRENCY_NAME.XRP,
        value: CRYPTO_CURRENCY_TYPE.XRP,
      },
    ],
  },
  keycloak: 'https://id.custody-dev.kgevde.com/',
  mixer: {
    columns: 20,
    rows: 20,
  },
  production: false,
  providers: [provideStoreDevtools({ maxAge: 50 })],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
